import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { debounceTime } from 'rxjs/operators';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class LaboratorioService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'laboratorio';
    this.token = new Login();
  }

  all(page = 1, buscar = '', paginate = 10){
    return this.http.get<Object[]>(this.url + '?page=' + page + '&q=' + buscar + '&paginate=' + paginate, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  search(buscar: any){
    return this.http.get<Object[]>(this.url+ '?q=' + buscar, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    }).pipe(debounceTime(5000));
  }

  criar(laboratorio : any) {
    return this.http.post<Object[]>(this.url, laboratorio, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
  
  ativar(idlaboratorio: any){
    return this.http.get<Object[]>(this.url+ '/ativar/' + idlaboratorio, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  inativar(idlaboratorio: any){
    return this.http.get<Object[]>(this.url+ '/inativar/' + idlaboratorio, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  atualizar(p : any) {
    return this.http.put<Object[]>(this.url + '/' + p.idlaboratorio, p, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }


  detalhar(idlaboratorio){
    return this.http.get<Object[]>(this.url + '/' + idlaboratorio, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}
